module.exports = __webpack_public_path__ + "media/src/assets/Images/Img-04e36609ab88252f139ae67e845e12ca.svg";